import { NgModule } from '@angular/core';
import { LayoutModule } from './components/layout/layout.module';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { MaterialModule } from './material.module';
import { CommonModule, DatePipe } from '@angular/common';
import { SpinnerService } from './services/spinner.service';
import { SessionStorageService } from './services/session-storage.service';
import { SnakbarService } from './services/snakbar.service';
import { AppPhoneNumberDirective } from './directives/phoneNumber.directive';
import { CustomPaginatorIntl } from './utility/customPaginator';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { AppPostalCodeDirective } from './directives/postalCode.directive';
import { AppDigitWithTwoDecimalNumberDirective } from './directives/digitsWithTwoDecimal.directive';
import { FocusClickOnTabDirective } from './directives/tab-focus-click.directive';

@NgModule({
  declarations: [
    AppPhoneNumberDirective,
    AppPostalCodeDirective,
    AppDigitWithTwoDecimalNumberDirective,
    FocusClickOnTabDirective,
  ],
  imports: [BreadcrumbComponent],
  exports: [
    LayoutModule,
    BreadcrumbComponent,
    MaterialModule,
    CommonModule,
    AppPhoneNumberDirective,
    AppPostalCodeDirective,
    AppDigitWithTwoDecimalNumberDirective,
    FocusClickOnTabDirective,
  ],
  providers: [
    SpinnerService,
    SnakbarService,
    SessionStorageService,
    { provide: MatPaginatorIntl, useClass: CustomPaginatorIntl },
    DatePipe,
  ],
})
export class SharedModule {}
